/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Mastercard/view.blocks to change it.
import CreditCardMasterCard from 'DesignSystem/Svgs/CreditCardMasterCard/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Mastercard({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/CardBrand/Mastercard"
  
}) {
  return (<React.Fragment
>
<CreditCardMasterCard
  viewPath={`${viewPath}/CreditCardMasterCard`}
 width={35}
 marginTop="auto"
 marginBottom="auto"
/>
{children}
</React.Fragment>)
}